import { render } from "./ActionForm.vue?vue&type=template&id=150bf848"
import script from "./ActionForm.vue?vue&type=script&lang=js"
export * from "./ActionForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodeapps/vitamins/projectivegroup/frontendBuild/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__